import { DataGate, PageBody } from '../components/shell/PageBody.tsx';
import { SecurityView } from '../features/audit-ops/SecurityView.tsx';
import { WhenRuns } from '../features/server/ModuleAbsent.tsx';

/** Security: what the detection rules raised, the kill switches, the rules, and backups. */
function SecurityPage() {
  return (
    <PageBody>
      <DataGate>
        <SecurityView />
      </DataGate>
    </PageBody>
  );
}

export default function Security() {
  return (
    <WhenRuns module="audit-ops" feature="Security reports" plural instead="The audit log keeps every action and approval today." size="page">
      <SecurityPage />
    </WhenRuns>
  );
}
